// extracted by mini-css-extract-plugin
module.exports = {"btn":"copy-content-button_btn__IL4J6","iconBtn":"copy-content-button_iconBtn__s3eM2"};